import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition } from "../common/models";
import { randomUUID } from "../../../utils";
import { RandomItemGenerationTask } from "./RandomItemGenerationTask";
import { useApiService } from "../../../../services/ApiServiceProvider";
import { useStorage } from "../../../../services/StorageProvider";
import { i18nLanguageToLabel } from "../../../utils";

const TUTORIAL_URLS: Record<string, string> = {
  'en': 'assets/videos/tutorials/Random_Item_Generation_v2.mp4',
  'es-419': 'assets/videos/tutorials/Random_Item_Generation_v2-es-419.mp4'
}

const Definition: AcousticTaskDefinition = {
  name: 'Random Item Generation (v2)',
  title: 'Random Item Generation',
  description: '',
  cohort: 'neurology',
  type: 'acoustic-task',
  estimatedCompletionTime: '2:00',
  subTaskDefinitions: [
    {
      name: `Random Item Generation (v2)`,
      instructions: '',
      title: '',
      content: null,
      profileName: 'speech',
      stopwatchSeconds: 60,
    }
  ],
};
export const RandomItemGenerationDefinition = Definition;

export const RandomItemGeneration =  ({onCompletion}: {onCompletion: () => void}) => {
  const { i18n } = useTranslation();
  const apiService = useApiService();
  const { storage } = useStorage();
  const session: any = storage.session;
  const [isRecording, setIsRecording] = useState(false);
  const [category, setCategory] = useState<string>('');
  const [task, _] = useState<AcousticTask>(() => {
    return ({
      ...Definition,
      id: randomUUID(),
      startedAt: new Date().toISOString(),
      completedAt: null,
      status: 'pending',
      subTasks: Definition.subTaskDefinitions.map((definition) => ({
        ...definition,
        id: randomUUID(),
      })),
      tutorialUrl: TUTORIAL_URLS[i18n.language] || TUTORIAL_URLS['en']
    });
  });

  const handleOnCompletion = async () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  const handleCreateQuestionnaire = async () => {
    const startAt = task.startedAt || new Date().toISOString();
    const completedAt = task.completedAt || new Date().toISOString();
    const payload = {
      sessionId: session.id,
      subjectId: session.subjectId,
      startedAt: startAt,
      completedAt: completedAt,
      acousticTaskId: task.id,
      category: category,
      language: i18nLanguageToLabel(i18n.language)
    };

    await apiService.createQuestionnaire('/api/randomItemGenerationQuestionnaires', payload);
  };

  const handleIsRecordingChange = (isRecording: boolean) => {
    setIsRecording(isRecording);
  };

  const handleCategoryChange = (category: string) => {
    setCategory(category);
  };

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
        onIsRecordingChange={handleIsRecordingChange}
        content={<RandomItemGenerationTask
          onCategoryChange={handleCategoryChange}
          isRecording={isRecording}
          cohort="neurology"/>}
        createQuestionnaire={handleCreateQuestionnaire}
      />
    </div>
  );
};


